var cmsTimers = {};

function cmsDropdownColors($dropdown) {
  var isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  $dropdown.css({ 'background-color': isDark ? '#242424' : '#fff', 'color': isDark ? '#e8e8e8' : '#333' });
}

// Skryj dropdown pokud klikneš mimo
$(document).on("click", function (e) {
  if (!$(e.target).closest(".complaint-multiselect").length) {
    $(".cms-dropdown").empty().hide();
  }
});

// Typing v search poli multi-selectu
$(document).on("input", ".complaint-multiselect .cms-input", function () {
  var $input     = $(this);
  var $container = $input.closest(".complaint-multiselect");
  var url        = $container.data("search-url");
  var term       = $input.val().trim();
  var $dropdown  = $container.find(".cms-dropdown");

  clearTimeout(cmsTimers[$container[0]]);

  if (term.length < 2) { $dropdown.empty().hide(); return; }

  cmsTimers[$container[0]] = setTimeout(function () {
    $.getJSON(url, { term: term }, function (items) {
      $dropdown.empty();
      cmsDropdownColors($dropdown);
      if (!items.length) { $dropdown.append('<div class="p-2 text-muted small">Nic nenalezeno</div>').show(); return; }
      items.forEach(function (item) {
        $("<div>").addClass("p-2 cms-dropdown-item").css("cursor", "pointer").text(item.label)
          .data("item", item)
          .appendTo($dropdown);
      });
      $dropdown.show();
    });
  }, 250);
});

// Výběr z dropdownu
$(document).on("mousedown", ".cms-dropdown-item", function (e) {
  e.preventDefault();
  var item       = $(this).data("item");
  var $container = $(this).closest(".complaint-multiselect");
  var paramName  = $container.data("param-name");
  var $chips     = $container.find(".cms-chips");
  var $hidden    = $container.find(".cms-hidden");
  var $input     = $container.find(".cms-input");
  var $dropdown  = $container.find(".cms-dropdown");

  // Nepřidávej duplicity
  if ($hidden.find("input[value='" + item.id + "']").length) { $input.val(""); $dropdown.empty().hide(); return; }

  // Chip
  var $chip = $("<span>").addClass("badge badge-secondary mr-1 mb-1");
  $chip.text(item.label + " ");
  var $rm = $("<a href='#'>").html("&times;").css("color", "white").on("click", function (ev) {
    ev.preventDefault();
    $hidden.find("input[value='" + item.id + "']").remove();
    $chip.remove();
  });
  $chip.append($rm).appendTo($chips);

  // Hidden input
  $("<input type='hidden'>").attr("name", paramName).val(item.id).appendTo($hidden);

  $input.val("");
  $dropdown.empty().hide();
});

// Autocomplete pro produkt v complaint_item řádku
var itemTimers = {};

// Vybrané objednávky a zásilky reklamace — našeptávač položek nabízí jen jejich řádky a produkty jejich skladu
function complaintSelection() {
  var ids = function (name) {
    return $("input[type=hidden][name='" + name + "']").map(function () { return this.value; }).get();
  };
  return { order_ids: ids("complaint[order_ids][]"), package_ids: ids("complaint[package_ids][]") };
}

function complaintItemSearch($input) {
  var url       = $input.data("search-url");
  var term      = $input.val().trim();
  var $dropdown = $input.siblings(".cms-item-dropdown");
  var selection = complaintSelection();
  var selected  = selection.order_ids.length || selection.package_ids.length;
  // řádky vybraných objednávek se nabídnou i bez psaní
  var minLength = $input.hasClass("complaint-item-di-search") && selected ? 0 : 2;

  clearTimeout(itemTimers[$input[0]]);

  if (term.length < minLength) { $dropdown.empty().hide(); return; }

  itemTimers[$input[0]] = setTimeout(function () {
    $.getJSON(url, $.extend({ term: term }, selection), function (items) {
      $dropdown.empty();
      cmsDropdownColors($dropdown);
      if (!items.length) { $dropdown.append('<div class="p-2 text-muted small">Nic nenalezeno</div>').show(); return; }
      items.forEach(function (item) {
        $("<div>").addClass("p-2 cms-item-dropdown-item").css("cursor", "pointer").text(item.label)
          .data("item", item)
          .appendTo($dropdown);
      });
      $dropdown.show();
    });
  }, 250);
}

$(document).on("input", ".complaint-item-product-search, .complaint-item-di-search", function () {
  complaintItemSearch($(this));
});

$(document).on("focus", ".complaint-item-di-search", function () {
  complaintItemSearch($(this));
});

$(document).on("mousedown", ".cms-item-dropdown-item", function (e) {
  e.preventDefault();
  var item      = $(this).data("item");
  var $dropdown = $(this).closest(".cms-item-dropdown");
  var $input    = $dropdown.siblings("input[type=text]");
  $dropdown.siblings("input[type=hidden]").val(item.id);
  $input.val(item.label);
  $dropdown.empty().hide();
});

$(document).on("click", function (e) {
  if (!$(e.target).closest("td").find(".complaint-item-product-search, .complaint-item-di-search").length) {
    $(".cms-item-dropdown").empty().hide();
  }
});

// Předvyplnění chipů z hidden inputů při načtení stránky (edit form)
$(document).on("turbolinks:load", function () {
  $(".complaint-multiselect").each(function () {
    var $container = $(this);
    var paramName  = $container.data("param-name");
    var $chips     = $container.find(".cms-chips");
    var $hidden    = $container.find(".cms-hidden");
    $hidden.find("input[type=hidden]").each(function () {
      var $h    = $(this);
      var id    = $h.val();
      var label = $h.data("label") || id;
      if (!id) return;
      var $chip = $("<span>").addClass("badge badge-secondary mr-1 mb-1");
      $chip.text(label + " ");
      var itemId = id;
      var $rm = $("<a href='#'>").html("&times;").css("color", "white").on("click", function (ev) {
        ev.preventDefault();
        $hidden.find("input[value='" + itemId + "']").remove();
        $chip.remove();
      });
      $chip.append($rm).appendTo($chips);
    });
  });
});
